/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import EventControlForm from './sub_components/event/eventControlForm'
import * as eventService from '../services/eventService'
import Tree from 'react-animated-tree'
let userData = JSON.parse(localStorage.getItem("tokenData"))
class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: "",
      showPopup: false,
      eventData: [],
      isAdmin: userData.role === "Admin"?true:false,
      eventTypeId:"",
      competitionId:"",
      eventId:""
    };
  }
  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value })
  }
  componentDidMount() {
    this.loadData()
  }
  loadData() {
    eventService.getAdminEventControl().then((res) => {
      this.setState({ eventData: !!res.eventTypes?res.eventTypes:{} })
    })
  }
  updateEventTypeStatus(eventTypeId, activate) {
    if(userData.role !== 'Admin'){
      eventTypeId = eventTypeId.toString()
    }
    let body = { "eventTypeId": eventTypeId }
    if (activate) {
      eventService.activateEventType(body).then((res) => {
        if (res.isSuccess) {
          this.loadData()
        }
      })
    } else {
      eventService.deActivateEventType(body).then((res) => {
        if (res.isSuccess) {
          this.loadData()
        }
      })
    }
  }
  updateCompetitionStatus(compId, activate) {
    let body = { "competitionId": compId }
    if (activate) {
      eventService.activateCompetition(body).then((res) => {
        if (res.isSuccess) {
          this.loadData()
        }
      })
    } else {
      eventService.deActivateCompetition(body).then((res) => {
        if (res.isSuccess) {
          this.loadData()
        }
      })
    }
  }
  updateEventStatus(eventId, activate) {
    let body = { "eventId": eventId }
    if (activate) {
      eventService.activateEvent(body).then((res) => {
        if (res.isSuccess) {
          this.loadData()
        }
      })
    } else {
      eventService.deActivateEvent(body).then((res) => {
        if (res.isSuccess) {
          this.loadData()
        }
      })
    }
  }
  render() {
    return (
      <body className="bethubs">
        <Header history = {this.props.history} />
        <div className="wrapper">
          <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                <ul className="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="container-fluid container-padding-0">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="main-box mbhidedata">
                  <h5 className="text-blue">Event Control</h5>
                  <div className="row supermaster mt-3">
                    <div className="col-12 col-sm-12 col-md-12">
                    {Object.keys(this.state.eventData).length > 0 && Object.keys(this.state.eventData).map((sport_id, i) => {
                              let sport = this.state.eventData[sport_id]
                              return (
                                <Tree content={<>
                                  <span style={{ color: "#42c2e2", fontSize: 16, fontWeight: 'bold', textTransform: "capitalize" }}>{sport.eventType.name}</span>
                                  <label className="checkboxx">
                                    <input type="checkbox" checked={sport.isActive} onChange={() => { this.updateEventTypeStatus(sport.eventType.id, !sport.isActive) }} />
                                    <span className="checkmark1" style={{ marginLeft: "5px", marginTop: "-3px" }}></span>
                                  </label>
                                </>} visible>
                                  {Object.keys(sport.competitions).length > 0 && Object.keys(sport.competitions).map((comp_id, j) => {
                                    let comp = sport.competitions[comp_id]
                                    return (
                                      <Tree content={<>
                                        <span style={{ color: "#42c2e2", fontSize: 14, fontWeight: 'bold' }}>{comp.competition.name}</span>
                                        <label className="checkboxx">
                                          <input type="checkbox" checked={comp.isActive} onChange={() => { this.updateCompetitionStatus(comp_id, !comp.isActive) }} />
                                          <span className="checkmark1" style={{ marginLeft: "5px", marginTop: "-3px" }}></span>
                                        </label>
                                      </>}>
                                        {Object.keys(comp.events).map((evt_id, k) => {
                                          let evt = comp.events[evt_id]
                                          return (
                                            <Tree content={<>
                                              <span style={{ color: "#000000", fontSize: 14 }}>{evt.event.name} - </span>
                                              <span style={{ color: "#000000", fontSize: 14 }}>{new Date(evt.event.openDate).toLocaleString()}</span>
                                              <label className="checkboxx">
                                                <input type="checkbox" checked={evt.isActive} onChange={() => { this.updateEventStatus(evt_id, !evt.isActive) }} />
                                                <span className="checkmark1" style={{ marginLeft: "5px", marginTop: "-3px" }}></span>
                                              </label>
                                              <a onClick={() => { this.setState({ eventTypeId: sport_id, competitionId: comp_id, eventId: evt_id, showPopup: true }) }} style={{ color: "#000000", marginLeft: 10, fontSize: 14, fontWeight: 'bold', cursor: 'pointer', marginTop: 6 }}>Edit</a>
                                            </>} />
                                          )
                                        })}                                      
                                      </Tree>
                                    )
                                  })}
                                </Tree>
                              )
                            })}
                          </div>
                  </div>
                </div>
                <div className="main-box mbshowdata">
                  <h4 className="text-black text-center pt-5 ">This Page is Not Supported on Mobile Device.<br/> Please check in web Browser</h4>
                  <div className="text-center pt-3"><a href={"/dashboard"} className="btn btn-blue">Home</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {this.state.showPopup && <EventControlForm eventId={this.state.eventId} competitionId={this.state.competitionId} eventTypeId={this.state.eventTypeId} isAdmin={this.state.isAdmin} closeForm={() => { this.setState({ showPopup: false }) }} eventId={this.state.eventId} />}
      </body>
    )
  }
}

function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Auth);